var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatblaster(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.404 11.077H9.808A2.31 2.31 0 007.5 13.385V18a2.31 2.31 0 002.308 2.308h5.964l3.421 3.422a.922.922 0 001.576-.653v-2.77h.635A2.31 2.31 0 0023.712 18v-4.615a2.31 2.31 0 00-2.308-2.308zm-9.865 5.538a.923.923 0 11-.001-1.845.923.923 0 010 1.845zm3.692 0a.923.923 0 110-1.845.923.923 0 010 1.845zm3.692 0a.923.923 0 110-1.845.923.923 0 010 1.845z",
    fill: "#FAAD14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.654 0H2.308A2.31 2.31 0 000 2.308v4.615a2.31 2.31 0 002.308 2.308h.634V12a.923.923 0 001.576.653L7.94 9.23h6.714a2.31 2.31 0 002.308-2.308V2.308A2.31 2.31 0 0014.654 0zM4.788 5.538a.923.923 0 110-1.845.923.923 0 010 1.845zm3.693 0a.923.923 0 110-1.845.923.923 0 010 1.845zm3.692 0a.923.923 0 110-1.845.923.923 0 010 1.845z",
    fill: "#597EF7"
  })));
}

export default __webpack_public_path__ + "./fonts/chatblaster.1d72ba84b9a462574ef4055fa5b9bcc7.svg";
export { SvgChatblaster as ReactComponent };